import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useContext } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { PaymentMethodEnum } from "~/core/types/purchase-popup-2/PaymentMethodEnum";
import MunicipalityTx from "~/core/models/purchase-popup-2/MunicipalityTx";
import Web3MunicipalityTx from "~/core/models/purchase-popup-2/Web3MunicipalityTx";

interface Props {
    isCalledFromMap: boolean,
    paymentMethod: string;
    transactionObject: MunicipalityTx | Web3MunicipalityTx;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccessful',
  props: {
    isCalledFromMap: { type: Boolean, default: false },
    paymentMethod: null,
    transactionObject: null
  },
  emits: ['onOrderHistory', 'onFlowFinished'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { isCalledFromMap: boolean, paymentMethod: string, transactionObject: MunicipalityTx | Web3MunicipalityTx };





const {
    isCalledFromMap,
    paymentMethod,
    transactionObject,
} = toRefs(props);

const isMobile = useMobile();
const { store } = useContext();

const user = computed(() => store.getters['application/driver/authUser']);
const showOrderHistoryButton = computed(() => {
    const userWallet = user.value.walletAddress || user.value.relatedWalletAddress || '';
    const account = transactionObject.value?.account || '';
    const owner = transactionObject.value?.owner || '';

    return paymentMethod.value !== PaymentMethodEnum.WEB3_WALLET || (
        paymentMethod.value === PaymentMethodEnum.WEB3_WALLET
        && (userWallet.toLowerCase() === account.toLowerCase() || userWallet.toLowerCase() === owner.toLowerCase())
    );
});

const handleOrderHistory = () => {
    $emit('onOrderHistory')
}

const handleFlowFinished = () => {
    $emit('onFlowFinished');
}

return { __sfc: true,$emit, props, isCalledFromMap, paymentMethod, transactionObject, isMobile, store, user, showOrderHistoryButton, handleOrderHistory, handleFlowFinished }
}

})